export const SUPPORT_TAG_COLORS = [
  '#B42318',
  '#C4320A',
  '#B54708',
  '#857000',
  '#3B7A16',
  '#087E63',
  '#0E7490',
  '#175CD3',
  '#3538CD',
  '#6938EF',
  '#A83A87',
  '#475467'
]
